
import React from 'react';
import { 
  Brain, 
  Palette, 
  Globe, 
  ShoppingCart, 
  LayoutDashboard, 
  Bot, 
  Mail, 
  PenTool,
  Target,
  Flag,
  Presentation,
  Settings,
  ArrowRightCircle,
  LineChart,
  LifeBuoy,
  Compass,
} from 'lucide-react';

// Define tech icons mapping for categories
export const techIcons = {
  "🎯 Strategy": <Brain size={16} className="mr-1" />,
  "🎨 Design": <Palette size={16} className="mr-1" />,
  "💻 Development": <Globe size={16} className="mr-1" />,
  "🤖 AI & Automation": <Bot size={16} className="mr-1" />,
  "📈 Growth": <LineChart size={16} className="mr-1" />,
  "💪 Support": <LifeBuoy size={16} className="mr-1" />
};

// Services data organized by category with neutral colors
export const services = [
  // Strategy Services - Neutral
  {
    emoji: <Brain size={24} className="text-gray-700" />,
    title: "Brand Strategy",
    description: "Create compelling brand name, story, and identity.",
    tag: "🎯 Strategy",
    phase: "Launch",
    columnColor: "#888888",
    bgColor: "bg-gray-50"
  },
  {
    emoji: <Flag size={24} className="text-gray-700" />,
    title: "GTM Strategy",
    description: "Define channels and create launch plan for success.",
    tag: "🎯 Strategy",
    phase: "Launch",
    columnColor: "#888888",
    bgColor: "bg-gray-50"
  },
  {
    emoji: <Compass size={24} className="text-gray-700" />,
    title: "Product Roadmap",
    description: "Strategic planning to guide your product development.",
    tag: "🎯 Strategy",
    phase: "Build",
    columnColor: "#888888",
    bgColor: "bg-gray-50"
  },
  {
    emoji: <Presentation size={24} className="text-gray-700" />,
    title: "Fundraising Tools",
    description: "Pitch deck, memo, and intro emails for investors.",
    tag: "🎯 Strategy",
    phase: "Grow",
    columnColor: "#888888",
    bgColor: "bg-gray-50"
  },

  // Design & Development - Neutral
  {
    emoji: <Palette size={24} className="text-gray-700" />,
    title: "Logo & Visuals",
    description: "Professional logo, color palette, and typography.",
    tag: "🎨 Design",
    phase: "Build",
    columnColor: "#888888",
    bgColor: "bg-gray-50"
  },
  {
    emoji: <Globe size={24} className="text-gray-700" />,
    title: "Website Design",
    description: "Responsive landing pages and mobile-ready designs.",
    tag: "💻 Development",
    phase: "Build",
    columnColor: "#888888",
    bgColor: "bg-gray-50"
  },
  {
    emoji: <ShoppingCart size={24} className="text-gray-700" />,
    title: "Shopify & Ecomm",
    description: "Full-service online store setup and customization.",
    tag: "💻 Development",
    phase: "Build",
    columnColor: "#888888",
    bgColor: "bg-gray-50"
  },
  {
    emoji: <LayoutDashboard size={24} className="text-gray-700" />,
    title: "Product Design",
    description: "Wireframes and intuitive UI/UX design.",
    tag: "🎨 Design",
    phase: "Build",
    columnColor: "#888888",
    bgColor: "bg-gray-50"
  },

  // Growth & Automation - Neutral
  {
    emoji: <Bot size={24} className="text-gray-700" />,
    title: "AI Automations",
    description: "Smart workflows, chatbots, and task automation.",
    tag: "🤖 AI & Automation",
    phase: "Grow",
    columnColor: "#888888",
    bgColor: "bg-gray-50"
  },
  {
    emoji: <Mail size={24} className="text-gray-700" />,
    title: "CRM & Emails",
    description: "Setup flows and customer segmentation.",
    tag: "🤖 AI & Automation",
    phase: "Grow",
    columnColor: "#888888",
    bgColor: "bg-gray-50"
  },
  {
    emoji: <PenTool size={24} className="text-gray-700" />,
    title: "Content Creation",
    description: "Engaging Reels, posts, and copywriting.",
    tag: "📈 Growth",
    phase: "Launch",
    columnColor: "#888888",
    bgColor: "bg-gray-50"
  },
  {
    emoji: <Target size={24} className="text-gray-700" />,
    title: "Paid Ads Setup",
    description: "Meta, Google ads, and conversion tracking.",
    tag: "📈 Growth",
    phase: "Launch",
    columnColor: "#888888",
    bgColor: "bg-gray-50"
  },
  {
    emoji: <Settings size={24} className="text-gray-700" />,
    title: "Tech Stack Setup",
    description: "Notion, Zapier, Stripe integration and more.",
    tag: "🤖 AI & Automation",
    phase: "Build",
    columnColor: "#888888",
    bgColor: "bg-gray-50"
  },
  {
    emoji: <ArrowRightCircle size={24} className="text-gray-700" />,
    title: "Growth Funnels",
    description: "Lead capture, nurture, and conversion systems.",
    tag: "📈 Growth",
    phase: "Grow",
    columnColor: "#888888",
    bgColor: "bg-gray-50"
  },
  {
    emoji: <LineChart size={24} className="text-gray-700" />,
    title: "Analytics & Tracking",
    description: "KPIs, dashboards, and performance insights.",
    tag: "📈 Growth",
    phase: "Grow",
    columnColor: "#888888",
    bgColor: "bg-gray-50"
  },
  {
    emoji: <LifeBuoy size={24} className="text-gray-700" />,
    title: "Ongoing Support",
    description: "Technical upgrades, pivots, and launch support.",
    tag: "💪 Support",
    phase: "Grow",
    columnColor: "#888888",
    bgColor: "bg-gray-50"
  }
];

